import {
  aboutLocation,
  contactLocation,
  galleryLocation,
  homeLocation,
  menuCardLocation,
} from "../../constants/routing";

export const siteNavItems = [
  { label: "Home", to: homeLocation },
  { label: "Over ons", to: aboutLocation },
  { label: "Menu", to: menuCardLocation },
  { label: "Galerij", to: galleryLocation },
  { label: "Contact", to: contactLocation },
];
